<template>
  <v-dialog :value="dialog" width="700" persistent>
    <v-card>
      <v-container>
        <v-layout row wrap align-center justify-center class="text-xs-center">
          <v-flex xs12>
            <div class="my-2">
              <v-icon
                :style="{ fontSize:'46px',color:'#F57C01'}"
              >{{$vuetify.icons.rms_confirmation_alert}}</v-icon>
            </div>
            <div :class="['display-1','mb-3']">
              <strong>{{$t(title)}}</strong>
            </div>
            <div class="subheading my-4">{{ $t(message) }}</div>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6 class="pa-1">
                <v-btn
                  block
                  @click="onCancel"
                  color="grey darken-2"
                  large
                >{{$t('rms.button.cancel')}}</v-btn>
              </v-flex>
              <v-flex xs6 class="pa-1">
                <v-btn
                  block
                  @click="onConfirm"
                  color="orange darken-2"
                  large
                >{{$t('rms.button.continue')}}</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Confirmation",
  props: {
    dialog: {
      type: Boolean
    },
    title: {
      type: String,
      default: "rms.confirmation.title"
    },
    message: {
      type: String,
      default: "rms.confirmation.text"
    }
  },
  methods: {
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style></style>
